import { makeStyles } from '@material-ui/styles'

const styles = makeStyles((theme) => ({
  cardContainer: {
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  },
  plusButton: {
    justifyContent: 'flex-start',
    paddingInline: theme.spacing(2.5),
    paddingBlock: theme.spacing(1.5),
  },
  responsibleContainer: {
    display: 'flex',
    gap: theme.spacing(2),
  },
}))

export default styles
